module.exports = __webpack_public_path__ + "assets/img/home-card-active.acc420e5.png";